import React from 'react';
import { Card, CardContent, CardHeader } from './ui/card';
import { Button } from './ui/button';
import { CheckCircle, Sparkles } from 'lucide-react';
import { Badge } from './ui/badge';

export const Pricing = ({ options, onApplyClick, onPaymentClick }) => {
  return (
    <section className="section-padding container-padding section-gradient-light">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Investment <span className="gradient-text-green-purple">Options</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the pathway that aligns with your commitment
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {options.map((option, index) => (
            <Card
              key={index}
              className={`pricing-card ${option.popular ? 'popular' : ''} animate-fade-in-up stagger-${index + 1}`}
            >
              <CardHeader className="text-center pb-8 pt-8">
                {option.badge && (
                  <Badge className="mx-auto mb-4 badge-scholarship">
                    <Sparkles className="w-4 h-4 mr-1" />
                    {option.badge}
                  </Badge>
                )}
                <h3 className="text-2xl font-bold mb-2 text-gray-900">
                  {option.name}
                </h3>
                <div className="mt-4">
                  {option.originalPrice && (
                    <p className="text-lg text-gray-500 line-through mb-1">
                      {option.originalPrice}
                    </p>
                  )}
                  <p className="text-5xl font-bold text-gray-900">
                    {option.price}
                  </p>
                  <p className="text-gray-600 mt-2">One-time investment</p>
                </div>
              </CardHeader>

              <CardContent className="pb-8">
                <ul className="space-y-4 mb-8">
                  {option.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button
                  className={`w-full ${option.popular ? 'btn-primary-purple' : 'btn-primary-green'} btn-transition text-lg py-6 focus-ring`}
                  onClick={onApplyClick}
                >
                  {option.ctaText}
                </Button>

                {option.popular && (
                  <p className="text-center text-sm text-gray-600 mt-4">
                    Merit-based selection • 85%+ marks required
                  </p>
                )}
                {option.paymentType === 'installment' && (
                  <p className="text-center text-sm text-gray-600 mt-4">
                    First installment due at enrollment
                  </p>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <p className="text-gray-600">
            💳 Flexible payment plans available • 🎓 ROI-focused curriculum • 🌍 International certification
          </p>
        </div>
      </div>
    </section>
  );
};
